// Import libs
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Import assets
import './errorView.scss';

// Import components
import LenspireView from '../LenspireView';
import HeadlineModuleView from '../../Components/Modules/HeadlineModule/HeadlineModuleView';
import TextModuleView from '../../Components/Modules/TextModule/TextModuleView';

const ErrorView = props => (
  <LenspireView {...props}>
    <HeadlineModuleView>Error: {props.error}</HeadlineModuleView>
    <TextModuleView>Sorry, something went wrong.</TextModuleView>
  </LenspireView>
);

function mapStateToProps(state) {
  return {
    error: state.globalsState.error,
  };
}

ErrorView.propTypes = {
  match: PropTypes.shape().isRequired,
  error: PropTypes.string,
};

ErrorView.defaultProps = {
  error: '',
};


export default connect(mapStateToProps)(ErrorView);



// WEBPACK FOOTER //
// ./frontend/js/Views/ErrorView/ErrorView.jsx